.wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: start;
}

.screen {
  min-height: 0;
  width: 100%;
  height: 100%;
}
